import { Link } from "react-router-dom";
import { ArrowLeft, ShieldCheck } from "@phosphor-icons/react";
import PublicThemeControl from "@/components/PublicThemeControl";
import BrandLockup from "@/components/BrandLockup";

export default function LegalLayout({ eyebrow, title, updated, children }) {
  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header__inner">
          <Link to="/" className="legal-brand" aria-label="Back to Callsect">
            <BrandLockup className="brand-lockup--legal" />
          </Link>
          <div className="legal-header__tools">
            <PublicThemeControl compact />
            <Link to="/" className="legal-back">
              <ArrowLeft size={15} weight="bold" />
              Back to Callsect
            </Link>
          </div>
        </div>
      </header>

      <main className="legal-shell">
        <section className="legal-hero">
          <span className="legal-hero__mark" aria-hidden="true">
            <ShieldCheck size={24} weight="duotone" />
          </span>
          <div className="brand-eyebrow">{eyebrow}</div>
          <h1>{title}</h1>
          {updated && <p>Effective and last updated: {updated}</p>}
        </section>

        <article className="legal-copy">{children}</article>
      </main>

      <footer className="legal-footer">
        <div>
          <span>Callsect private beta</span>
          <nav aria-label="Legal documents">
            <Link to="/privacy">Privacy Notice</Link>
            <Link to="/terms">Private Beta Terms</Link>
            <Link to="/data-handling">Data handling</Link>
          </nav>
        </div>
      </footer>
    </div>
  );
}

export function Section({ title, children }) {
  return (
    <section className="legal-section">
      <h2>{title}</h2>
      <div>{children}</div>
    </section>
  );
}

export function LegalList({ children }) {
  return <ul className="legal-list">{children}</ul>;
}
